import savedSearchDrawerTemplate from './saved-search-drawer/savedSearchDrawer.html';
import savedSearchDrawerController from './saved-search-drawer/savedSearchDrawerController';

function savedSearchController(
  $scope,
  $log,
  $uibModal,
  savedSearchService,
  toastWrapperService,
  $translate,
  confirmationDialog
) {
  const controller = this;
  let selfInitiatedChange = false;

  $scope.savedSearches = [];

  $scope.$on('$locationChangeSuccess', () => {
    if (!selfInitiatedChange) {
      $scope.activeSearch = null;
    }

    selfInitiatedChange = false;
  });

  $scope.edit = (savedSearch) => {
    const modalInstance = $uibModal.open({
      template: savedSearchDrawerTemplate,
      controller: 'savedSearchDrawerController',
      windowClass: 'story-drawer',
      resolve: {
        savedSearchData() {
          if (savedSearch) {
            return savedSearch;
          }

          const filters = savedSearchService.processDates({
            filters: $scope.filterSet.getActiveFiltersSet()
          });

          // a clean search obj
          return {
            params: {},
            filters,
            name: null
          };
        }
      }
    });

    modalInstance.result.then((data) => {
      savedSearchService.processRawSearch(data);

      if (savedSearch) {
        _.remove($scope.savedSearches, savedSearch);
      }
      $scope.savedSearches.push(data);
    });
  };

  $scope.delete = (search) => {
    const successCallback = () => $scope.deleteSavedSearch(search);
    confirmationDialog.confirm('CONFIRM_DELETE_SAVED_SEARCH', successCallback);
  };

  $scope.deleteSavedSearch = (search) => {
    savedSearchService.delete(search)
      .then(() => {
        _.remove($scope.savedSearches, search);
      }, (response) => {
        $log.error('savedSearch.controller savedSearchService.delete() error', response.error || response);
        toastWrapperService.createToast($translate.instant('ERROR_DELETING_SAVED_SEARCH'), 'danger');
      });
  };

  $scope.apply = (search) => {
    selfInitiatedChange = true;
    savedSearchService.applySearch(search);
    $scope.activeSearch = search;
  };

  $scope.isActiveSearch = search => _.isEqual(search, $scope.activeSearch);

  controller.getSearches = () => {
    $scope.requestRunning = true;

    savedSearchService.getAll()
      .then((data) => {
        data.results.forEach(savedSearchService.processRawSearch);
        $scope.savedSearches = data.results;
        $scope.requestRunning = false;
        $scope.initialized = true;
      }, () => {
        $scope.requestRunning = false;
      });
  };

  controller.getSearches();
}

const ctrlArr = [
  '$scope',
  '$log',
  '$uibModal',
  'savedSearchService',
  'toastWrapperService',
  '$translate',
  'confirmationDialog',
  savedSearchController
];

export default function (ngModule) {
  ngModule.controller('savedSearchController', ctrlArr);
  savedSearchDrawerController(ngModule);
}
